export const dateFormatter = date => {
  if (date) {
    const formattedDate = new Date(date);
    return formattedDate.toLocaleDateString('EN-GB');
  }
  return null;
};
